import { Component, inject, Input } from "@angular/core";
import { CoreIconButton, CorePopover, SvsModalService } from "@svs/angular";
import { catchError } from "rxjs";
import { ChatBotService, FeedbackRequestFeedbackEnum } from "../../../../../api";
import { ChatStore, Message } from "../../../../@core/state/chat.store";
import { FeedbackModalComponent } from "./feedback-modal/feedback-modal.component";
import { FeedbackPopoverComponent } from "./feedback-popover/feedback-popover.component";

@Component({
  selector: "app-chat-answer-feedback",
  imports: [
    CoreIconButton,
    CorePopover,
    FeedbackPopoverComponent,
  ],
  templateUrl: "./chat-answer-feedback.component.html",
  styleUrl: "./chat-answer-feedback.component.scss",
})
export class ChatAnswerFeedbackComponent {
  chatBotService = inject(ChatBotService);
  chatStore = inject(ChatStore);
  modal = inject(SvsModalService);

  feedback?: FeedbackRequestFeedbackEnum;
  padding = { bottom: 150 };
  @Input({ required: true }) message!: Message;

  positiveFeedback(popover: CorePopover) {
    popover.hide();

    if (this.feedback === FeedbackRequestFeedbackEnum.Good) {
      return;
    }
    this.submitFeedback(FeedbackRequestFeedbackEnum.Good);
  }

  openPopOver(popover: CorePopover, reasons?: string[]) {
    if (!!reasons) {
      popover.hide();
    } else {
      popover.show();
    }
    this.submitFeedback(FeedbackRequestFeedbackEnum.Bad, reasons);
  }


  openModal() {
    let ref = this.modal.open(FeedbackModalComponent);
    ref.modalRef.result.then(reasons => {
      this.submitFeedback(FeedbackRequestFeedbackEnum.Bad, reasons);
    });
    this.submitFeedback(FeedbackRequestFeedbackEnum.Bad);
  }

  private submitFeedback(feedback: FeedbackRequestFeedbackEnum, reasons: string[] = []) {
    this.feedback = feedback;
    const { question, answer } = this.message;

    this.chatBotService.giveFeedback({
      feedback,
      answer,
      question,
      feedback_message: reasons?.length ? reasons.join(", ") : "",
      conversation_id: this.chatStore.conversationId(),
    }).pipe(catchError(e => {
      this.feedback = undefined;
      throw e;
    })).subscribe();
  }
}
